import { createContext } from 'react';

import { QuestionSearchItem } from '@core/types/types.common';
import { DBQuestion } from '@core/types/types.db';

export const QuestionContext = createContext<
  QuestionSearchItem | DBQuestion | null
>(null);
